export default [
    'ColdHot',
    'RedYellowGreen'
]